module.exports = __webpack_public_path__ + "static/img/lxpantos-renewal2022.251ccf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lxpantos-renewal2022.jpg
// module id = Eb1U
// module chunks = 0